var exports = {
  "n": "x31de4314--3df0c4--link",
};

module.exports = exports;
